export const TimeController = {
  _timeOfDayMap: ["Morning", "Afternoon", "Evening", "Night"],

  DayTime: {
    MORNING: 'Morning',
    AFTERNOON: 'Afternoon',
    EVENING: 'Evening',
    NIGHT: 'Night'
  },
  DayTimeEnum: {
    MORNING: 'Morning',
    AFTERNOON: 'Afternoon',
    EVENING: 'Evening',
    NIGHT: 'Night'
  },

  _changeDayTime: () => {
    let currentIndex = YsControllers.TimeController._timeOfDayMap.indexOf($gameSystem._timeProgress.dayTime);
    currentIndex++;
    $gameSystem._timeProgress.dayTime = YsControllers.TimeController._timeOfDayMap[currentIndex];
    Yosemite.MainUI.refreshStats();
  },

  checkCurrentLocation: () => {
    if(!Yosemite.PreEnterMap.isAllowedDayTime($gameSystem._timeProgress.dayTime)) {
      Yosemite.PreEnterMap.changeMap('cityMap');
    }
  }
};

TimeController.nextDay = () => {
  $gameSystem._timeProgress.dayTime = YsControllers.TimeController._timeOfDayMap[0];
  $gameSystem._timeProgress.dayCount += 1;
  Yosemite.EventStateManager.resetDayRestrictedEvents();
  Yosemite.MainUI.refreshStats();
};

TimeController.nextTimeDay = () => {
  if($gameSystem._timeProgress.dayTime === YsControllers.TimeController.DayTime.NIGHT) {
    YsControllers.TimeController.handleNextDay();
    return;
  }
  Yosemite.EventStateManager.removeDrinkCount(1);
  YsControllers.TimeController._changeDayTime();
  Yosemite.EventStateManager.hasWorkedMarketingToday = false;
  Yosemite.EventStateManager.hasWorkedITToday = false;
};

TimeController.goSleep = () => {
  Yosemite.SaveLoad.autosave();
  YsControllers.TimeController.nextDay();
};

TimeController.takeNap = () => {
  YsControllers.TimeController.nextTimeDay();
};

TimeController.takeLongerNap = () => {
  Yosemite.EventStateManager.removeDrinkCount(2);
  YsControllers.TimeController._changeDayTime();
  YsControllers.TimeController._changeDayTime();
};

TimeController.getCurrentDayTime = () => {
  return $gameSystem._timeProgress.dayTime;
};

TimeController.getCurrentDayCount = () => {
  return $gameSystem._timeProgress.dayCount;
};

TimeController.setEvening = () => {
  $gameSystem._timeProgress.dayTime = YsControllers.TimeController._timeOfDayMap[2];
  Yosemite.MainUI.refreshStats();
};

TimeController.setNight = () => {
  $gameSystem._timeProgress.dayTime = YsControllers.TimeController._timeOfDayMap[3];
  Yosemite.MainUI.refreshStats();
};

TimeController.setAfternoon = () => {
  $gameSystem._timeProgress.dayTime = YsControllers.TimeController._timeOfDayMap[1];
  Yosemite.MainUI.refreshStats();
};

TimeController.setMorning = () => {
  $gameSystem._timeProgress.dayTime = YsControllers.TimeController._timeOfDayMap[0];
  Yosemite.MainUI.refreshStats();
};

TimeController.handleNextDay = () => {
  YsControllers.TimeController.nextDay();
}

TimeController.isEveningOrNight = () => {
  return YsControllers.TimeController.getCurrentDayTime() === YsControllers.TimeController.DayTime.NIGHT ||
    YsControllers.TimeController.getCurrentDayTime() === YsControllers.TimeController.DayTime.EVENING
}

const _Yosemite_Shop_Game_System_initialize = Game_System.prototype.initialize;
Game_System.prototype.initialize = function() {
  _Yosemite_Shop_Game_System_initialize.call(this);
  if(!this._timeProgress) {
    this._timeProgress = {
      dayTime: TimeController._timeOfDayMap[0],
      dayCount: 1,
    };
  }
};
